import "./App.css";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import store from "../src/redux/store";
import { ConfigProvider } from "antd";
import Navigation from "./routes/Navigation";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import "react-toastify/dist/ReactToastify.css";
import locale from "antd/locale/fr_FR";
import dayjs from "dayjs";

import "dayjs/locale/fr";

dayjs.locale("fr");

function App() {
  return (
    <ConfigProvider
      locale={locale}
      theme={{
        token: {
          colorPrimary: "#c3ae6e",
        },
      }}
    >
      <Provider store={store}>
        <ToastContainer autoClose={2000} theme="colored" />
        <Navigation />
      </Provider>
    </ConfigProvider>
  );
}

export default App;
